import { render, staticRenderFns } from "./EmployerReport.vue?vue&type=template&id=5b02a0d2&lang=pug"
import script from "./EmployerReport.vue?vue&type=script&lang=js"
export * from "./EmployerReport.vue?vue&type=script&lang=js"
import style0 from "./EmployerReport.vue?vue&type=style&index=0&id=5b02a0d2&prod&lang=scss&__scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Editable: require('/home/docker/code/frontend/components/Editable.vue').default,EmployerReportCell: require('/home/docker/code/frontend/components/EmployerReportCell.vue').default,ChartBars: require('/home/docker/code/frontend/components/chart/Bars.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
